<template lang="pug">
  pagina
</template>

<script>
  import Pagina from 'MODULES/Pagina'

  export default {
    components: { Pagina },
    data () {
      return {
        breadcrumb: [
          { nome: 'Layout' }
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Generica.vue?1445d86c